<template lang="html">
  <div class="wcc calculator">
    <transition-group name="fade" mode="out-in">
      <Summary v-if="calculatorData.collapsed" key="summary" :calculatorData="calculatorData"></Summary>
      <Fields v-show="!calculatorData.collapsed" key="fields" :calculatorData="calculatorData"></Fields>
    </transition-group>
    <Results :calculatorData="calculatorData"></Results>
    <Email :calculatorData="calculatorData"></Email>
  </div>
</template>
<script>
  import Fields from './Fields/Fields.vue'
  import Summary from './Summary.vue'
  import Results from './Results/Results.vue'
  import Email from './Email/Email.vue'
  export default {
    props: ['calculatorData'],
    components: {
      Fields,
      Summary,
      Results,
      Email
    }
  }
</script>
<style lang="scss">

@keyframes blink-border {
  50% {
    border-color: transparent;
  }
}

.wcc.calculator {
  width: 100%;
  display: flex;
  flex-direction: column;
  &:not(:first-of-type) {
    border-top: $spacing solid $grey-200;
  }
}
</style>